<template>
    <!-- <v-list class="transparent">
      <v-list-item>
        <v-list-item-subtitle class="text-wrap pb-3"
          >Lorem ipsum dolor, sit amet consectetur adipisicing elit. In
          reiciendis qui obcaecati quasi assumenda ad iste magni? Vitae atque ab
          beatae ratione, obcaecati ad illo officia, quod deserunt dolor
          molestiae.
        </v-list-item-subtitle>
      </v-list-item>
      <v-divider></v-divider>
    </v-list> -->
    <!-- <v-list v-for="item in about" :key="item.title" class="transparent">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold mb-3">{{
            item.title
          }}</v-list-item-title>
          <v-img :src="item.src" class="mx-auto mb-2" max-width="100"></v-img>
          <v-list-item-subtitle
            class="text-wrap mb-2"
            v-for="(element, index) in item.elements"
            :key="index"
          >
            {{ element.subtitle }}</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </v-list> -->

    <v-container
        class="pa-0"
        :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
    >
        <h1 class="px-4">{{ $t("market.cricket_about.header1") }}</h1>
        <div class="cricket">
            <h2 class="pa-4 pb-0">{{ $t("market.cricket_about.header2") }}:</h2>
            <v-card-text>
                <div
                    class="mb-2"
                    v-html="
                        $t(
                            domainType === 'SuperWin'
                                ? 'market.cricket_about.p1_superwin'
                                : 'market.cricket_about.p1'
                        )
                    "
                >
                    <!-- <i18n path="market.cricket_about.p1" tag="p">
            <template #bettings>
              <a :href="cricket">{{ $t('market.cricket_about.betting') }}</a>
            </template>
            <template #mainSite>
              <a :href="cricket">{{ $t('market.cricket_about.default') }}</a>
            </template>
          </i18n> -->
                </div>
                <div class="mb-2">
                    {{ $t("market.cricket_about.p2") }}
                </div>
            </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="match-winner">
            <h2 class="pa-4 pb-0">{{ $t("market.cricket_about.header3") }}:</h2>
            <v-card-text>
                <!-- v-for="item in matchWinner" :key="item.title" -->
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <!-- v-for="item in item.paras" :key="item.para" -->
                            <v-card-text class="pa-0 mb-2">
                                <!-- v-html="item.para" -->
                                {{ $t("market.cricket_about.p3") }}
                            </v-card-text>
                            <v-card-text class="pa-0 mb-2">
                                {{ $t("market.cricket_about.p4") }}
                            </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/cricket-odds.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/cricket-odds.png`"
                            contain
                            class="mx-auto"
                            max-height="210"
                            alt="cricket odds"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>
        </div>

        <!-- <v-divider></v-divider>
    <div class="match-odds">
      <v-card-title class="">Match Odds:</v-card-title>
      <v-card-text v-for="item in matchOdds" :key="item.title">
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <div v-for="item in item.paras" :key="item.para">
              <v-card-text class="pa-0 mb-2" v-html="item.para"> </v-card-text>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-img
              :src="require(`@/assets/images/${item.src}.png`)"
              contain
              class="mx-auto"
              max-height="250"
            ></v-img>
          </v-col>
        </v-row>
      </v-card-text>
    </div> -->

        <v-divider></v-divider>
        <div class="fancy">
            <h2 class="pa-4 pb-0">{{ $t("market.cricket_about.header4") }}:</h2>
            <v-card-text>
                <!-- v-for="item in fancy" :key="item.title" -->
                <div class="font-weight-bold">
                    {{ $t("market.cricket_about.header5") }}:
                </div>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <!-- v-for="(item, index) in item.paras" :key="index" -->
                            <v-card-text class="pa-0 mb-2">
                                <!-- v-html="item.para" -->
                                {{ $t("market.cricket_about.p5") }}
                            </v-card-text>
                            <v-card-text class="pa-0 mb-2 font-italic">
                                {{ $t("market.cricket_about.p6") }}
                            </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <!-- v-if="item.src" -->
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/cricket-fall.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/cricket-fall.png`"
                            contain
                            class="mx-auto mb-2"
                            max-height="100"
                            alt="cricket fall"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <div class="font-weight-bold">
                    {{ $t("market.cricket_about.header6") }}:
                </div>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <v-card-text class="pa-0 mb-2">
                                {{ $t("market.cricket_about.p7") }}
                            </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/cricket-runs.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/cricket-runs.png`"
                            contain
                            class="mx-auto mb-2"
                            max-height="100"
                            alt="cricket runs"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <div class="font-weight-bold">
                    {{ $t("market.cricket_about.header7") }}:
                </div>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <v-card-text class="pa-0 mb-2">
                                {{ $t("market.cricket_about.p8") }}
                            </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/cricket-lambi.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/cricket-lambi.png`"
                            contain
                            class="mx-auto mb-2"
                            max-height="148"
                            alt="cricket lambi"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <div class="font-weight-bold">
                    {{ $t("market.cricket_about.header8") }}:
                </div>
                <v-row no-gutters>
                    <v-col cols="12" md="6">
                        <div>
                            <v-card-text class="pa-0 mb-2">
                                {{ $t("market.cricket_about.p9") }}
                            </v-card-text>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-img
                            :src="`${CDN_IMG_URL}/market-inside/cricket-over.png`"
                            :lazy-src="`${CDN_IMG_URL}/market-inside/cricket-over.png`"
                            contain
                            class="mx-auto mb-2"
                            max-height="100"
                            alt="circket over"
                        ></v-img>
                    </v-col>
                </v-row>
            </v-card-text>
        </div>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            domainType: process.env.APP_TITLE,
            cricket: "/sportsbook/cricket",
            CDN_IMG_URL: process.env.CDN_IMG_URL,
            matchWinner: [
                {
                    src: "lay",
                    paras: [
                        {
                            para: "<div>Back- Means betting in favor of the team mentioned on the left. Backing the team.</div>"
                        },
                        {
                            para: "<div>Lay- Means betting against the team mentioned in the left. (In case of Test matches, there's a concept of draw as well. Hence, when laying a team/draw in a Test match, means backing the other two outcomes.</div>"
                        },
                        {
                            para: "<div>In case the back odds are 1.46, on placing a bet of 1000, the returns are calcuated as 1000*0.46 i.e. 460 Rs. While calculating profit, 1 is always deducted from the mentioned rate to get at profit.</div>"
                        },
                        {
                            para: "<div>In case the lay odds are 1.85, on placing a bet of 1000, the returns are 1000, and on losing, 1000*0.85 i.e. 850 is deducted. Its inverse calculations of the Back odds.</div>"
                        },
                        {
                            para: "<div>During Back odds, stakes put are multiplied with the rate given. During lay odds, stakes put are considered as the payout and the multiplication is the loss suffered in case result goes the other way.</div>"
                        }
                    ]
                }
            ],
            fancy: [
                {
                    title: "Fall of Wicket:",
                    src: "fall",
                    paras: [
                        {
                            para: "<div>Bet on when the wicket shall fall in line with the score. A score would be given with No and Yes options. You have to chose whether the wicket will fall within that score or not.</div>"
                        },
                        {
                            para: "<div><i>**in case the wicket doesnt fall, the bets are voided**</i></div>"
                        }
                    ]
                },
                {
                    title: "Batsman Runs:",
                    src: "runs",
                    paras: [
                        {
                            para: "<div>Bet on how much runs a batsman shall score. A score would be given with No and Yes options. Choose whether the batsman will score that number or not.</div>"
                        }
                    ]
                },
                {
                    title: "Lambi Runs:",
                    paras: [
                        {
                            para: "<div>Bet on the final innings score of the batting team. A score would be given with No and Yes options. Chose whether the team will score the said runs or not.</div>"
                        }
                    ]
                },
                {
                    title: "Over Sessions:",
                    src: "over",
                    paras: [
                        {
                            para: "<div>Bet on the score at the end of the said number of overs. A score would be given with No and Yes options. Choose whether the said score would be made or not.</div>"
                        }
                    ]
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    text-decoration: none;
    font-weight: bold;
}
</style>
